import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { Chart } from 'chart.js';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-conversion',
  templateUrl: './conversion.component.html',
  styleUrl: './conversion.component.scss'
})
export class ConversionComponent implements OnInit, OnDestroy {
  constructor(private dashboardService: DashboardService) { }
  @ViewChild('conversion', { static: false }) conversion: ElementRef;
  loading: boolean;
  chart: Chart<'bar', number[], unknown>;
  percentageConvTarget: number;
  percentagePurchaseConversionPct: number;
  noDataAvailable: boolean;
  noData: boolean;
  isDesktopDisplay: boolean;
  private unsubscribe$ = new Subject<void>()

  ngOnInit(): void {
    this.dashboardService.buyerStatsData.pipe(takeUntil(this.unsubscribe$)).subscribe(result => {
      this.noData = result.purchaseConversionPct <= 0 || result.conversionTarget < 0;
      if (result.periodType !== 'WTD' || result.previousWeek) {
        result.conversionTarget = 0;
      }
      if (result.purchaseConversionPct > 0 && result.conversionTarget >= 0) {
        if (this.chart) {
          this.chart.destroy();
        }
        this.createChart(result.purchaseConversionPct, result.conversionTarget);
      } else if (!result.purchaseConversionPct && !result.conversionTarget || result.purchaseConversionPct <= 0) {
        if (this.chart) {
          this.chart.destroy();
        }
      }
    })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  createChart(purchaseConversionPct: number, convTarget: number) {
    const ctx = document.getElementById('conversionCanvas') as HTMLCanvasElement;
    this.percentageConvTarget = this.dashboardService.convertToPercentage(convTarget);
    this.percentagePurchaseConversionPct = this.dashboardService.convertToPercentage(purchaseConversionPct);
    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: [""],
        datasets:
          [
            {
              label: 'CNV',
              data: [this.percentagePurchaseConversionPct],
              backgroundColor: '#02A844',
              barPercentage: 0.8,
              categoryPercentage: 1,
              borderSkipped: 'end',
            },
            {
              label: 'Target',
              data: [this.percentageConvTarget],
              backgroundColor: '#6C13B0',
              barPercentage: 0.8,
              categoryPercentage: 1,
            },
          ],
      },
      options: {
        responsive: true,
        aspectRatio: 0.67,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              boxWidth: 10,
              boxHeight: 10,
              pointStyle: "rect",
              generateLabels(chart) {
                return chart.data.datasets.map((dataset, i) => {
                  const value = dataset.data[0];
                  if (value === 0) return null;

                  return {
                    text: dataset.label,
                    fillStyle: dataset.backgroundColor as string | CanvasGradient | CanvasPattern,
                    hidden: !chart.isDatasetVisible(i),
                    datasetIndex: i
                  };
                }).filter(label => label !== null);
              }
            },
            align: 'center',
          },
        },
        scales: {
          x: {
            grid: {
              display: false,
            }
          },
          y: {
            beginAtZero: true,
            min: 0,
            max: 100,
            grid: {
              display: false,
            },
          }
        }
      },
    });
  }
}
